module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_j_normal.2c4f4ae4.png";